import { getCardTypesFromAPI } from '@ratehub/cc-common';

import { Products } from '../definitions/Products';


/**
 * Maps the credit cards productList from the search API (Config.SEARCH_API_URL) response
 * into the prop shape expected by the FeaturedProductList component chain.
 * @param {Array<{productType: string, products: Array}>} productList - productList from search API
 * @returns {Array<object>} Flat array of products in FeaturedProductList prop shape
 */
export default function mapCreditCardSearchToFeaturedProductListProps(productList) {
    if (!Array.isArray(productList)) {
        return [];
    }

    return productList.flatMap((group) =>
        (group?.products || []).map((card) => ({
            // FeaturedProductGroup — required for filtering valid products
            id: card.ids?.primary || card.slug,
            productType: Products.CREDIT_CARDS,

            // FeaturedProduct — required props
            title: card.name,
            isSponsored: card.sponsored?.global || false,
            hasPromo: !!card.gift_cards,
            applyHref: card.urls?.apply || card.urls?.details || '',
            imageSrc: card.urls?.image || '',
            imageAlt: card.name,
            description: card.descriptions?.badge || '',

            // FeaturedProductGroup — optional props
            productTypeOverride: card.types?.comparison || undefined,
            providerName: card.provider?.name || '',

            // CreditCardShape — only fields used by FeaturedProduct/CreditCardCTA
            product: {
                id: card.ids?.primary || card.slug,
                name: card.name,
                isMonetized: card.monetized || false,
                isSponsored: card.sponsored?.global || false,
                detailsURL: card.urls?.details || '',
                bank: card.provider?.name || '',
                cardTypes: getCardTypesFromAPI(card),
                giftCardOffer: card.gift_cards || null,
                hasReferralOffer: card.referral_offer || false,
                referralOfferValue: card.referral_value || 0,
                prohibitedProvinces: card.prohibited_provinces || [],
            },
        })),
    );
}
